import { render, staticRenderFns } from "./UpdateDiagnosticCategory.vue?vue&type=template&id=2811e57b"
import script from "./UpdateDiagnosticCategory.vue?vue&type=script&lang=js"
export * from "./UpdateDiagnosticCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports